import {h, Fragment} from "preact"
import { useFacets, useSort } from "@nosto/preact"
import { useEffect } from "preact/hooks";
import { sortOptions } from "../../config"


export default function Select({ value, onChange, className, isActive, setActive, }) {

    const { activeSort, setSort } = useSort(sortOptions);
    const options = sortOptions.map(o => ({ value: o.id, label: o.value.name }))


    const handleSortChange = (e, val) => {
        document.querySelectorAll(".results-sort__sort-option").forEach(el =>{
            el.classList.remove("active-sort");
        })
        setSort(val);
        e.target.parentElement.classList.add("active-sort");
    }

    useEffect(()=>{
      // hack to select the first sorting option by default upon page load
      document.querySelectorAll((".ns-serp li.results-sort__sort-option label")).forEach((el, index) =>{
        if(index == 0) el.click();
      })

      document.querySelectorAll(".ns-sidebar-dropdown.group.nosto-sort a").forEach(el => el.click());
      
    }, [])


    return (
      <li class={`ns-sidebar-dropdown group nosto-sort ns-active`}>
        <a
          class="ns-d-flex ns-justify-content-between ns-relative ns-w-100 ns-border-box ns-text-undecorated ns-pt-4 ns-pb-4"
          href="javascript:void(0)"
          data-nosto-element="facet"
        >
          <span class="nosto-facet-name">Sorting</span>
          <span class="accordion__trigger-indicator">
              <svg aria-label="Plus icon" class="icon icon--plus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.6 0.6H23.4V23.4H0.6V0.6Z" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke" class="icon-outline"></path>
                  <path d="M12 5.45459V12M12 12H5.45459M12 12H18.5455M12 12V18" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke"></path>
              </svg>

              <svg aria-label="Minus icon" class="icon icon--minus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.6 0.6H23.4V23.4H0.6V0.6Z" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke" class="icon-outline"></path>
                  <path d="M18.5455 12H5.45459" stroke="currentColor" stroke-width="1.2" vector-effect="non-scaling-stroke"></path>
              </svg>
          </span>
        </a>
        <div class="ns-sidebar-submenu ns-d-none  ns-pt-4 ns-pb-4">
          <ul class="ns-list-unstyled ns-p-0 ns-m-0 nosto-facets-list ddown">
            {options.map((option, index) => (
              <li data-nosto-element="facet-setting" class={`${option.value} results-sort__sort-option`}>
                <input onClick={e => handleSortChange(e, option.value)} type="radio" id={option.value} name="sort_by" value="manual" />
                <label onClick={e => handleSortChange(e, option.value)} for={option.value}>{option.label}</label>
                {index != 0 && index % 2 != 0 && <svg aria-label="Down arrow icon" class="icon icon--arrow-down" width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7.16667L7.5 10.5M7.5 10.5L11 7.16667M7.5 10.5L7.5 3.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="square"></path></svg>}
                {index != 0 && index % 2 == 0 && <svg aria-label="Up arrow icon" class="icon icon--arrow-up" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M3.5 6.83333L7 3.5M7 3.5L10.5 6.83333M7 3.5L7 10.5" stroke="currentColor" stroke-width="1.2" stroke-linecap="square"></path> </svg>}
            </li>
            ))}
          </ul>
        </div>
      </li>
    );
  }
  